<app-inventory-details-toolbar
  [inventory]="inventory"
  [isAddGLHidden]="false"
  [isAddGLDisabled]="false"
  [isAddPricingHidden]="true"
  [isAddPricingDisabled]="true"
  [isCreateOrderHidden]="false"
  [isCreateOrderDisabled]="true"
  [isEditInventoryDisabled]="true"
  [isDocumentAction]="false"
  [isPricingDocumentAction]="false"
  [isNotesOn]="($activeSiderSection | async) == SECTIONS.NOTES_SECTION_NAME"
  [isHistoryOn]="($activeSiderSection | async) == SECTIONS.HISTORY_SECTION_NAME"
  (backRequested)="back()"
  [isCSVDisabled]="false"
  [isFilterDisabled]="true"
  [notesCount]="notesCount"
  
  (addGLRequested)="addString()"
  (toggleNotesRequested)="toggleNotes()"
  (toggleHistoryRequested)="toggleHistory()"
  (downloadCSVRequested)="onDownloadCSVRequested()"
>
</app-inventory-details-toolbar>
<mat-sidenav-container class="app-content tabbed-content dx-nodata-absolute">
  <app-inventory-details-tabs [activeTabIndex]="4"></app-inventory-details-tabs>
  <div class="app-content app-content-list dx-nodata-absolute" style="height: 100%">
    <dx-data-grid
      #glCodeGrid
      style="height: 100%; padding-bottom: 50px;"
      class="app-grid-with-pager charge-browser-grid"
      [columns]="previewGridColumns"
      [dataSource]="selectedCodings"
      [showRowLines]="true"
      [showColumnLines]="false">
    </dx-data-grid>
  </div>
  <ca-pager
    class="app-pager ca-default-border-top"
    [pageContext]="glRuleStringGridService"
    [query]="glQuery"
    (onChange)="changeGlPage()">
  </ca-pager>
  <mat-sidenav #panelSide
               [mode]="'side'"
               position="end"
               [opened]="false">
    <ca-history
      #history
      [entityId]="inventory?.id"
      [ngClass]="{'hidden': !sider?.isActive(SECTIONS.HISTORY_SECTION_NAME)}"
      [entityType]="'inventory-gl-string'">
    </ca-history>

    <ca-notes
      [entityId]="inventory?.id"
      [entityType]="SYSTEM_MODULE.INVENTORY"
      [ngClass]="{'hidden': !sider?.isActive(SECTIONS.NOTES_SECTION_NAME)}"
      (countChanged)="onNotesCountChanged($event)">
    </ca-notes>
  </mat-sidenav>
</mat-sidenav-container>
